import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleEmbeddedDatasource } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { Messages } from '../../../codegen/Localize';
import { IDataQualityAction } from '../../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { setDataQualityAction } from '../../actions/dataQuality/SetDataQualityAction';
import { setDataQualityTriggerAction } from '../../actions/dataQuality/SetDataQualityTriggerAction';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const SetDataQualityEntityAction: IEntityAction<IContentInfo, IDataQualityAction> = {
  name: EntityActionNames.SetDataQuality,
  translateName: Messages.dataQuality_action,
  isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && !isSingleEmbeddedDatasource(items),
  isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDataQuality was called without exactly one item');
    }

    return setDataQualityAction(items[0]);
  }
};


export const SetDataQualityTriggerAction: IEntityAction<IContentInfo, IDataQualityAction> = {
  name: EntityActionNames.SetDataQualityTrigger,
  translateName: (items, _state) => {
    if (items[0].contentType === 'datasource') {
      return Messages.dataQualityTrigger_action_datasource();
    } else {
      return Messages.dataQualityTrigger_action_flow();
    }
  },
  isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && !isSingleEmbeddedDatasource(items),
  isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDataQualityTrigger was called without exactly one item');
    }

    return setDataQualityTriggerAction(items[0]);
  }
};


export const DataQualitySubmenu: IEntityAction<IContentInfo, IDataQualityAction> = {
  name: EntityActionNames.DataQualitySubmenu,
  translateName: Messages.dataQuality_action_submenu,
  isVisible: (items, state) => SetDataQualityEntityAction.isVisible(items, state) || SetDataQualityTriggerAction.isVisible(items, state),
  isClickable: (a, t, s) => SetDataQualityEntityAction.isClickable(a, t, s) || SetDataQualityTriggerAction.isClickable(a, t, s),
  createReduxAction: () => null // The menu widget doesn't let "submenu" items be clicked
};

export const DataQualityMenu: IEntityAction<IContentInfo, IDataQualityAction> = {
  name: EntityActionNames.SetDataQuality,
  translateName: Messages.dataQuality_action,
  isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && !isSingleEmbeddedDatasource(items),
  isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDataQuality was called without exactly one item');
    }

    return setDataQualityAction(items[0]);
  }
};
